(function () {
  function moneyFormat() {
    return (window.theme && theme.moneyFormat) || window.t_moneyFormat || "${{amount}}";
  }

  function fmt(cents) {
    if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(cents, moneyFormat());
    // fallback (rare)
    return (cents / 100).toFixed(2);
  }

  function updateBox(box, v) {
    if (!box || !v) return;

    var saveTag = box.querySelector(".t4-save-tag");
    var saveAmt = box.querySelector(".t4-save-amount");
    var saleMoney = box.querySelector(".t4-sale-price .money");
    var regularRow = box.querySelector(".t4-regular-price");
    var regularDel = box.querySelector(".t4-regular-price del");

    // sale price always
    if (saleMoney) saleMoney.innerHTML = fmt(v.price);

    // on sale?
    var onSale = v.compare_at_price && v.compare_at_price > v.price;

    if (onSale) {
      var diff = v.compare_at_price - v.price;

      if (saveAmt) saveAmt.innerHTML = fmt(diff);
      if (regularDel) regularDel.innerHTML = fmt(v.compare_at_price);

      if (saveTag) saveTag.style.display = "";
      if (regularRow) regularRow.style.display = "";
    } else {
      if (saveTag) saveTag.style.display = "none";
      if (regularRow) regularRow.style.display = "none";
    }
  }

  function findAllPriceBoxes() {
    // catches price_ppr, price_qv, etc
    return document.querySelectorAll(".price_range[id^='price']");
  }

  // update on variant change
  document.addEventListener("variant:change", function (e) {
    if (!e.detail || !e.detail.variant) return;
    var v = e.detail.variant;

    findAllPriceBoxes().forEach(function (box) {
      updateBox(box, v);
    });
  });
})();
